export enum ApplicationTypeModalSource {
  CLERK = 'CLERK',
  PUBLIC = 'PUBLIC',
}
